/**
 * @fileoverview Shared labels and react-select styles for the Corporate Identity section.
 */

/** Translation key for the "not visible field" message */
export const NOT_VISIBLE_FIELD_MESSAGE_KEY =
  "components.corporateIdentity.notVisibleFieldMessage";

/** CSS cursor value for disabled/read-only elements */
export const CURSOR_NOT_ALLOWED = "not-allowed";

export const referencedDataSelectProps = {
  getOptionLabel: (option) => option.nombre,
  getOptionValue: (option) => String(option._id),
};

export const disabledSelectStyles = {
  control: (baseStyles) => ({
    ...baseStyles,
    borderRadius: "8px",
    fontSize: "14px",
    cursor: CURSOR_NOT_ALLOWED,
    borderColor: baseStyles.borderColor,
    marginBottom: "-10px",
  }),
  container: (baseStyles) => ({
    ...baseStyles,
  }),
  valueContainer: (baseStyles) => ({
    ...baseStyles,
  }),
  input: (baseStyles) => ({
    ...baseStyles,
  }),
  option: (baseStyles) => ({
    ...baseStyles,
    cursor: "pointer",
  }),
  indicatorSeparator: () => ({ display: "none" }),
};
